export default [
    ['COMMON', '通用'],
    ['INF', '接口'],
    ['SYS', '系统'],
    ['TMPL', '模板'],
]
